import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { Fragment, useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { ExtranetPackage } from 'app/typings/packages';

import {
  PER_PERSON,
  formatExperienceTooltipText,
  getSumOfPerPersonExperience,
} from '../../Utils';

import './PriceReminder.scss';

type PriceReminderProps = {
  pkg: ExtranetPackage;
};

const NB_GUEST = 2;

export const PriceReminder = ({ pkg }: PriceReminderProps) => {
  const { currencyFormatter } = useContext(CurrencyContext);
  const { data: experienceCategories } = useExperiencesCategories();

  const includedExperiences = pkg.experiences?.filter(
    (exp) => exp.included[pkg.id] && exp.published
  );

  const sumPrice = getSumOfPerPersonExperience(includedExperiences);

  return (
    <div className="price-reminder-container">
      <span className="price-reminder-container__price">
        {currencyFormatter(sumPrice * NB_GUEST)}
      </span>
      <span className="price-reminder-container__description">
        for two guests{' '}
        <span className="price-reminder-container__price-detail">
          ({currencyFormatter(sumPrice)}
          {PER_PERSON})
        </span>
      </span>
      {!!includedExperiences.length && (
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title={includedExperiences.map((exp, index) => (
            <Fragment key={exp.id}>
              {formatExperienceTooltipText(
                exp,
                experienceCategories ?? [],
                currencyFormatter
              )}
              {index + 1 !== includedExperiences.length && ' + '}
            </Fragment>
          ))}
        >
          <QuestionCircleOutlined className="price-reminder-container__icon" />
        </Tooltip>
      )}
    </div>
  );
};
